<template>
    <router-link
        class="block btn-primary muted"
        :to="{ name: 'account.notes.show', params: { accountId: account.id} }"
    >Notes ({{ account.notes_count || 0 }})</router-link>
</template>

<script>
    export default {
        name: 'NotesDrawerButton',
        props: {
            account: {
                type: Object,
                required: true,
            },
        },
    }
</script>
